import { NeuroMessage, useProduct, useDispatch } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components';
import PropTypes from 'prop-types';
import React from 'react';
import Collapsible from 'react-collapsible';
import ReactSVG from 'react-svg';
import { GROUP_TYPE } from './constants.mjs';
import { productSelected } from '../actions/commerce-business-branch-actions.mjs';

const Product = ({ product, summary, isDetails = false, isExisting = false, setShowProductModal, setSelectedProduct, isSubmittedProduct, setInitialActiveTab }) => {
  const {
    description,
    disclosures,
    descriptionAbbreviated,
    features,
    name,
    url,
    onSelectClick,
    isSelected
  } = useProduct(product);

  const cssBEM = 'product';
  const containerClass = summary ? `${cssBEM}__addOns ${cssBEM}__addOns_collapsible-qr` : `${cssBEM}__addOns`
  const messageContext = useNeuroMessages();
  const { getMessage } = useNeuroMessages();
  const productIcon = messageContext.getMessage(`${product.id}.icon`);
  let productName = messageContext.getMessage(`${product.id}.name`)?.replace(/(<([^>]+)>)/gi, "")?.replace(/\s/g, "")?.replace(/[^\w]/g, '');
  productName = productName?.toLowerCase()
  const isTrends = () => product?.groupType === GROUP_TYPE.businessTrends;
  const isResources = () => product?.groupType === GROUP_TYPE.resources;
  const isAddOns = () => product?.groupType === GROUP_TYPE.addOns;
  const dispatch = useDispatch();
  const crossSellAddOns = [2405, 2407, 2409, 2709, 2406, 2408, 2411, 2740];

  const unorderedDisclosures = [
    2640,
    2642,
    2644,
    2646,
    2684
  ]

  const excludeInterestedNow = [
    2720
  ]

  const isCrossSellAddOnProduct = () => {
    return crossSellAddOns.includes(product.id);
  } 

  const shouldRenderInterestedNow = () => {
    return !excludeInterestedNow.includes(product.id);
  }

  const getDiscTag = (id) => {
    unorderedDisclosures.includes
    if (unorderedDisclosures.includes(id)) {
      return 'ul'
    } else return 'ol';
  }

  const renderProductIcon = () => {

    return <div className={`${cssBEM}__icon`}>
      <ReactSVG src={!productIcon ? '/classpath/assets/images/icons/icon-default.svg' : productIcon} />
    </div>;
  };

  const renderProductName = () => {
    return name ?
      <div className={`${cssBEM}__header`}>
        <h2><a href={url} target="_blank"><NeuroMessage id={`${product.id}.name`} /></a></h2>
      </div> : null;
  };

  const renderProductDescription = () => {
    return description ?
      <div className={`${cssBEM}__description`}>
        <p>{description}</p>
        {renderProductFeatures()}
      </div> : null;
  };

  const onModalClick = (tabName) => {
    setSelectedProduct(product);
    setInitialActiveTab(tabName);
    setShowProductModal(true);
  };

  const onSelectHandler = () => {
    onSelectClick();
    dispatch(productSelected());
  }

  const renderProductDescriptionAbreviated = () => {
    return descriptionAbbreviated ?
      <div className={`${cssBEM}__description`}>
        <p>{descriptionAbbreviated}</p>
        {(!isDetails && !isTrends()) && (
          <div className={`${cssBEM}__description__cta`}>
            <button className="btn" onClick={() => onModalClick('features')}>
            <NeuroMessage id='products.features.title' />
            <ReactSVG src="/classpath/assets/images/icons/arrow_forward.svg" wrapper="span"/>
          </button>
          { product.addOns?.length > 0 && ( <button className="btn" onClick={() => onModalClick('addons')}>
            <NeuroMessage id='product.addOns' />
            <ReactSVG src="/classpath/assets/images/icons/arrow_forward.svg" wrapper="span" />
          </button>)}
          </div>
        )}
        {isDetails && renderProductFeatures()}
      </div> : null;
  };

  const renderProductFeatures = () => {
    return features.length > 0 ?
      <div className={`${cssBEM}__features`}>
        <Collapsible
          classParentString="collapsible"
          className={'product__collapsible'}
          openedClassName={'product__collapsible--addOns'}
          contentInnerClassName="collapsible__content"
          {...(isDetails && { triggerDisabled: true, open: true })}
          trigger={
            <>
              <NeuroMessage id='products.features.title' tagName='button' className={`${cssBEM}__features--title btn`} />
            </>
          }
        >
          <ul>{features.map((f, i) => <li key={i}>{f}</li>)}</ul>

        </Collapsible>
      </div> : null;
  };

  const TrendsAndInsights = ({ children, productParam }) => {
    const { onProductActionClick: onActionClick } = useProduct(productParam);
    const onTrendClick = () => onActionClick({ actionName: 'productDetailsClicked', value: 'learnMore', append: true });
    return (
      <li onClick={onTrendClick}>
        {isDetails ? <Product product={productParam} /> :
          <span>
            <span>{children}</span>
            <ReactSVG wrapper="span" className="icon" src="/classpath/assets/images/icons/arrow_forward.svg"></ReactSVG>
          </span>}
      </li>
    );
  };

  const renderProductAddOns = () => {
    const addOnCount = isTrends() ? getMessage('businessTrends.count') : product.addOns.length;

    return (
      product.addOns?.length > 0 && (
        <Collapsible
          classParentString="collapsible"
          className={'product__collapsible'}
          openedClassName={'product__collapsible--addOns'}
          contentInnerClassName="collapsible__content"
          {...(isTrends() ? { open: true } : isDetails && { triggerDisabled: true, open: true })}
          trigger={
            <>
              <NeuroMessage id={isResources() ? 'product.resources' : isTrends() ? 'product.trends' : 'product.addOns'} tagName="div" />
              {!isDetails && <i className="fa fa-angle-down"></i>}
            </>
          }
        >
          <div className={containerClass}>
            <ul className={`${cssBEM}__addOns-list`}>
              {product.addOns.map((ele, _id) => (
                <ConditionalWrapper
                  condition={isTrends()}
                  wrap={children => <TrendsAndInsights productParam={ele}>{children}</TrendsAndInsights>}
                >
                  {isDetails ? <Product product={ele} /> : <NeuroMessage id={`${ele.id}.name`} tagName={`${isTrends() ? 'span' : 'li'}`} />}
                </ConditionalWrapper>
                )
              ).slice(0, addOnCount)}
            </ul>
            {summary && !isTrends() ? <div className="enrollment-qr-code">
              <NeuroMessage id='summary.enrollmentQRCode.title' tagName='h4' />
              <img src="/classpath/assets/images/enrollment-qr-code.jpg" alt="enrollment-qr-code" />
            </div> : null}
          </div>
        </Collapsible>
      )
    );
  };

  const renderProductDisclosures = (Tag = 'ol') => {
    return disclosures.length > 0 ?
      <div className={`${cssBEM}__disclosures`}>
        <NeuroMessage id='product.disclosure.title' tagName='h2' className='productDisclosures__title' />
        <Tag>{disclosures.map((f, i) => <li key={i}>{f}</li>)}</Tag>
        <NeuroMessage id={`${product.id}.disclosures.subtext`} shouldHideIfNotFound={true} tagName='span' className='productDisclosures__subtext' />
      </div> : null;
  };
  const interestedIcon = isSelected ?  "fa fa-check" : "fa fa-plus-square-o"


  return (
    !isAddOns() && (
      <div className={productName === "smallbusinessonlinebanking" ? `${cssBEM} ${productName} container-qr` : `${cssBEM} ${productName}`} key={product.id}>
        {renderProductIcon()}
        <div className={`${cssBEM}__container`}>
          {isExisting && <NeuroMessage id={`product.existing`} className={`${cssBEM}__existing`} tagName='p' />}
          {renderProductName()}
          <div className={`${cssBEM}__container--details`}>
            {summary ? renderProductDescriptionAbreviated() : renderProductDescription()}
          </div>
          {(isDetails || isCrossSellAddOnProduct()) && renderProductDisclosures(getDiscTag(product.id))}
          {(isDetails || isTrends()) && renderProductAddOns()}
          {(!isDetails && !isTrends()) && (
            <div className={`${cssBEM}__container__cta`}>
              <button className="btn" onClick={() => onModalClick('features')}><NeuroMessage id={'products.seeMore'} /></button>
              {shouldRenderInterestedNow() && (
                <button className={`btn ${isSelected ? 'selected' : 'unselected'}`} onClick={onSelectHandler} disabled={isSubmittedProduct}><NeuroMessage id={isSelected ? 'products.interested' : 'products.interestedNow'} />
                  <i className={interestedIcon}></i>
                </button>
              )}
            </div>
          )}
        </div>
       {productName === "smallbusinessonlinebanking" ? <div className="enrollment-qr-code">
          <NeuroMessage id='summary.enrollmentQRCode.title' tagName='h4' />
          <img src="/classpath/assets/images/enrollment-qr-code.jpg" alt="enrollment-qr-code" />
        </div> : null}
      </div>
    )
  );
};

const ConditionalWrapper = ({condition, wrap, children}) => condition ? wrap(children) : children;

Product.propTypes = {
  product: PropTypes.object.isRequired,
  summary: PropTypes.bool,
  isDetails: PropTypes.bool,
  isExisting: PropTypes.bool,
  setShowProductModal: PropTypes.func,
  setSelectedProduct: PropTypes.func,
  setInitialActiveTab: PropTypes.func, // Add this line
};

export default Product;
